// Deliberately not `as const`: the leaves must widen to `string` so the English
// catalogue can satisfy the same shape. The keys stay literal, which is what
// `TKey` is built from.
export const de = {
  app: { name: 'StaySuite' },
  account: {
    title: 'Konto',
    customerNumber: 'Kundennummer',
    imprint: 'Impressum',
    privacy: 'Datenschutz',
    terms: 'AGB',
    privacyLong: 'Datenschutzerklärung',
    support: 'Bei Rückfragen bitte die Kundennummer angeben.',
  },
  kontoLoeschung: {
    // Vorgang 019: Konto-Löschung in der App (Apple 5.1.1(v)). KEIN Betrag in
    // diesen Texten; die einzige Zahl ist die Karenzfrist, und die kommt zur
    // Laufzeit aus `konto_loeschung_vorschau()` ({tage}). Wortlaut ist der
    // F3-Vorschlag — Abnahme durch René steht aus (ADR-019-Nachtrag, V4).
    eintrag: 'Konto löschen',
    titel: 'Konto löschen',
    intro: 'Ihr StaySuite-Konto wird gelöscht: Ihr Zugang, Ihre Anmeldedaten und Ihre Mitgliedschaften. Die Löschung wird vorgemerkt und nach {tage} Tagen vollzogen — bis dahin können Sie sie jederzeit abbrechen, indem Sie sich anmelden.',
    neuStartLeer: 'Eine spätere Registrierung mit derselben E-Mail-Adresse beginnt leer. Ihre bisherigen Daten sind dann nicht mehr zugänglich.',
    belegeBleiben: 'Ausgestellte Rechnungen und ihre Stornobelege unterliegen der gesetzlichen Aufbewahrungspflicht. Sie werden nicht gelöscht, sondern ruhend aufbewahrt, bis die Frist abgelaufen ist.',
    betriebZu: 'Sie sind einziger Inhaber: Ihr Betrieb „{name}“ wird geschlossen.',
    mitgliedVerliert: '1 weiteres Mitglied verliert den Zugriff.',
    mitgliederVerlieren: '{n} weitere Mitglieder verlieren den Zugriff.',
    aboStripe: 'Ihr Abo wird zum Ende der laufenden Abrechnungsperiode beendet.',
    aboApple: 'Ihr Abo läuft über Apple. Kündigen Sie es selbst in den iOS-Einstellungen unter „Abos“ — die Löschung wartet nicht darauf.',
    aboGoogle: 'Ihr Abo läuft über Google Play. Kündigen Sie es selbst im Play Store unter „Abos“ — die Löschung wartet nicht darauf.',
    passwort: 'Passwort',
    passwortHint: 'Zur Bestätigung geben Sie das Passwort Ihres Kontos ein.',
    bestaetigen: 'Konto löschen',
    reauthFehler: 'Die Bestätigung ist fehlgeschlagen. Bitte prüfen Sie Ihre Eingabe und versuchen Sie es erneut.',
    vormerkenFehler: 'Das hat gerade nicht geklappt. Bitte versuchen Sie es erneut.',
    vorschauFehler: 'Die Übersicht konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
    erneut: 'Erneut versuchen',
    fertig: 'Ihre Löschung ist vorgemerkt. Ihr Konto wird am {datum} gelöscht.',
    fertigAbmeldung: 'Sie werden jetzt abgemeldet. Wenn Sie sich vor diesem Datum wieder anmelden, können Sie die Löschung noch abbrechen.',
    abmelden: 'Verstanden — abmelden',
    dialogTitel: 'Ihr Konto wird gelöscht',
    dialogText: 'Ihr Konto wird am {datum} gelöscht. Bis dahin können Sie die Löschung abbrechen und wie gewohnt weiterarbeiten.',
    dialogTextOhneDatum: 'Für Ihr Konto ist eine Löschung vorgemerkt. Bis zum Ablauf der Frist können Sie sie abbrechen und wie gewohnt weiterarbeiten.',
    dialogAbbrechen: 'Löschung abbrechen',
    dialogBeibehalten: 'Löschung beibehalten',
    dialogFehler: 'Das hat gerade nicht geklappt. Bitte versuchen Sie es erneut.',
  },
  checkin: {
    title: 'Online-Check-in',
    arrivingAround: 'Ankunft gegen',
    registration: 'Meldeschein',
    open: 'Noch nicht ausgefüllt',
    submitted: 'Meldeschein liegt vor',
  },
  books: {
    title: 'Auswertung',
  },
  nav: {
    calendar: 'Kalender',
    bookings: 'Buchungen',
    guests: 'Gäste',
    billing: 'Abrechnung',
    rates: 'Preise',
    settings: 'Einstellungen',
    settingsShort: 'Konto',
    billingShort: 'Kasse',
    today: 'Heute',
    more: 'Mehr',
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    new: 'Neu',
    back: 'Zurück',
    search: 'Suchen',
    none: 'Keine',
    from: 'von',
    to: 'bis',
    nights: 'Nächte',
    night: 'Nacht',
    adults: 'Erwachsene',
    children: 'Kinder',
    total: 'Gesamt',
    net: 'Netto',
    vat: 'USt.',
    gross: 'Brutto',
    open: 'Offen',
    paid: 'Bezahlt',
    loading: 'Wird geladen …',
    noResults: 'Nichts gefunden',
    optional: 'optional',
  },
  status: {
    enquiry: 'Anfrage',
    quoted: 'Angebot',
    option: 'Option',
    confirmed: 'Bestätigt',
    checked_in: 'Angereist',
    checked_out: 'Abgereist',
    cancelled: 'Storniert',
    no_show: 'No-Show',
    block: 'Sperre',
  },
  channel: {
    direct: 'Direkt',
    website: 'Website',
    phone: 'Telefon',
    email: 'E-Mail',
    booking_com: 'Booking.com',
    airbnb: 'Airbnb',
    vrbo: 'Vrbo/FeWo',
    other: 'Sonstige',
  },
  calendar: {
    title: 'Belegungskalender',
    unit: 'Einheit',
    free: 'Frei',
    occupancy: 'Auslastung',
    arrivals: 'Anreisen',
    departures: 'Abreisen',
    conflict: 'Konflikt mit Portal-Kalender',
    month: 'Monat',
    dragHint: 'Zeitraum ziehen, um zu buchen',
    // Steht am Griff selbst und in der Fußzeile. „Ende" statt „Rand": der Vermieter
    // zieht an Anreise oder Abreise, nicht an einer Kante.
    gripHint: 'An den Enden ziehen ändert An- und Abreise',
    rowHeightHint: 'Ziehen ändert die Zeilenhöhe · Doppelklick setzt zurück',
    newBooking: 'Neue Buchung',
    blockDates: 'Zeitraum sperren',
    // Klartext für den Balken im Kalender: was die Symbole bedeuten und was auf
    // schmalen Balken gar nicht erst gezeichnet wird. Siehe BookingBadges.
    bar: {
      adult: '1 Erwachsener',
      adults: '{n} Erwachsene',
      child: '1 Kind',
      children: '{n} Kinder',
      prepayNone: 'Keine Anzahlung verlangt',
      prepayOpen: 'Anzahlung offen',
      prepayReceived: 'Anzahlung eingegangen',
      invoiceNone: 'Noch keine Rechnung',
      invoiceMissing: 'Aufenthalt vorbei, noch keine Rechnung',
      invoiceDraft: 'Rechnung erst als Entwurf',
      invoiceOpen: 'Rechnung gestellt, noch offen',
      invoiceOverdue: 'Rechnung überfällig',
      invoicePaid: 'Rechnung bezahlt',
      invoiceCancelled: 'Rechnung storniert',
      pet: 'Haustier gebucht',
    },
  },
  booking: {
    title: 'Buchung',
    reference: 'Nummer',
    channel: 'Kanal',
    extras: 'Zusatzleistungen',
    guest: 'Gast',
    unit: 'Einheit',
    arrival: 'Anreise',
    departure: 'Abreise',
    occupancy: 'Belegung',
    price: 'Preis',
    breakdown: 'Aufstellung',
    prepayment: 'Anzahlung',
    ofTotal: 'vom Gesamtpreis',
    deposit: 'Kaution',
    notes: 'Notiz für den Gast',
    address: 'Straße und Hausnummer',
    postcode: 'PLZ',
    city: 'Ort',
    docLanguage: 'Dokumentsprache',
    internalNotes: 'Interne Notiz',
    createQuote: 'Angebot erstellen',
    createInvoice: 'Rechnung erstellen',
    registration: 'Meldeschein',
    perNight: 'pro Nacht',
    minNights: 'Mindestaufenthalt {n} Nächte',
    tooManyGuests: 'Mehr Gäste als die Einheit zulässt ({max})',
    overlaps: 'Zeitraum ist bereits belegt',
    departureBeforeArrival: 'Die Abreise muss nach der Anreise liegen',
    softOverlap: 'Achtung: {who} hat für diesen Zeitraum bereits eine Anfrage — die Einheit ist noch nicht fest belegt.',
    optionUntil: 'Option gültig bis',
    optionUntilHint: 'Danach wird die Einheit automatisch wieder freigegeben',
    optionExpiring: 'Optionen laufen bald ab',
    optionExpires: 'Option läuft heute ab',
    optionExpiresIn: 'Option läuft in {n} Tagen ab',
  },
  deposit: {
    title: 'Kaution',
    not_required: 'Nicht erforderlich',
    due: 'Offen',
    held: 'Einbehalten',
    partially_retained: 'Teilweise verrechnet',
    retained: 'Verrechnet',
    released: 'Zurückgezahlt',
    release: 'Kaution zurückzahlen',
    retain: 'Von Kaution einbehalten',
  },
  fee: {
    cleaning: 'Endreinigung',
    tourist_tax: 'Ortstaxe',
    linen: 'Bettwäsche',
    pet: 'Haustier',
    parking: 'Stellplatz',
    extra_person: 'Zusatzperson',
    extra_person_child: 'Zusatzperson (Kind)',
    child_discount: 'Kinderermäßigung',
    accommodation: 'Übernachtung',
    discount: 'Rabatt',
  },
  quote: {
    title: 'Angebot',
    valid_until: 'Gültig bis',
    send: 'Angebot senden',
    accepted: 'Angenommen',
    declined: 'Abgelehnt',
  },
  mail: {
    // StaySuite verschickt keine Gastpost. Der Beleg geht über das eigene
    // Mailprogramm des Vermieters hinaus — mit seiner Adresse und seiner Signatur.
    ownProgram: 'Verschickt wird aus Ihrem eigenen Mailprogramm: den Beleg hier '
      + 'drucken oder als PDF sichern und selbst an den Gast senden.',
  },
  document: {
    print: 'Drucken',
    savePdf: 'PDF sichern',
    // In der Hülle öffnet dasselbe Tun das Teilen-Blatt — dort ist „sichern"
    // das falsche Wort, weil der Vermieter das Ziel selbst wählt.
    sharePdf: 'PDF teilen',
    preparing: 'PDF wird vorbereitet …',
    // Kein Fehlercode, sondern der Satz, der sagt, was zu tun ist.
    draftBlocked: 'Diese Rechnung ist noch ein Entwurf und trägt keine Nummer. '
      + 'Schreiben Sie sie zuerst fest — danach entsteht das PDF.',
    charsetBlocked: 'Das Zeichen „{z}“ lässt sich im PDF nicht setzen. Der Name '
      + 'wird nicht umgeschrieben — bitte melden Sie das, dann wird die Schrift erweitert.',
    saveFailed: 'Die Datei konnte nicht übergeben werden. Bitte noch einmal versuchen '
      + 'oder den Beleg drucken.',
    pdfFailed: 'Das PDF konnte nicht erzeugt werden. Der Beleg lässt sich weiterhin drucken.',
  },
  invoice: {
    title: 'Rechnung',
    number: 'Rechnungsnummer',
    issued: 'Rechnungsdatum',
    due: 'Fällig',
    cancel: 'Stornieren',
    cancelReason: 'Grund für den Storno (erscheint auf der Gutschrift):',
    cancelled: 'Storniert',
    creditNote: 'Gutschrift',
    payLink: 'Zahlungslink',
    issue: 'Festschreiben',
    draftHint: 'Entwurf — noch ohne Rechnungsnummer und jederzeit änderbar. Mit „Festschreiben“ wird die Nummer vergeben und die Rechnung unveränderbar.',
    draft: 'Entwurf',
    archive: 'Rechnungsarchiv',
    drafts: 'Entwürfe',
    overdue: 'Überfällig',
    markPaid: 'Als bezahlt markieren',
    collect: 'Kassieren',
    paidOn: 'Betrag dankend erhalten am',
    smallBusiness: 'Kleinunternehmer gemäß § 6 Abs. 1 Z 27 UStG — keine Umsatzsteuer.',
  },
  rksv: {
    // Vorgang 018, Schnitt 2: Bestellstrecke und Modulstatus des
    // RKSV-Zusatzmoduls. KEIN Betrag in diesen Texten (AK12) — {preis} wird
    // zur Laufzeit aus modul_preise gefüllt, und der Stundensatz der
    // Supportklausel steht als Verweis, nie als Zahl (F7).
    modul: {
      titel: 'Zusatzmodul Fiskalisierung',
      beschreibung: 'Signierte Belege über eine Cloud-Registrierkasse (fiskaltrust), eingerichtet von AUVISO — als zubuchbares Zusatzmodul.',
      preisMonat: '{preis} pro Monat zzgl. USt.',
      bestellt: 'Bestellt — wird eingerichtet.',
      // F5 (Vorschlag 2, als Text — gilt nur bei RKSV_PRODUKTIV = on):
      zusage: 'Ihre Kasse ist in der Regel binnen zwei Werktagen aktiv.',
      // AK13, ehrlicher Termin solange das Rahmenvertrags-Gate zu ist:
      termin: 'Echte Aktivierungen sind erst nach Unterschrift des fiskaltrust-Rahmenvertrags möglich — voraussichtlich Mitte Oktober. Ihre Bestellung ist vorgemerkt; wir melden uns, sobald es losgeht.',
      aktivAb: 'Aktiv seit {datum}',
      zuschlagAb: 'Zuschlag ab {datum}',
      mindestbezugBis: 'Mindestbezug bis {datum}',
      gekuendigtZum: 'Gekündigt zum {datum}',
      storniert: 'Bestellung storniert.',
    },
    bestellung: {
      einstieg: 'Fiskalisierung bestellen',
      nurOwner: 'Den Modulstand sehen Sie hier; bestellen oder kündigen kann nur der Inhaber des Kontos.',
      nurWeb: 'Das Modul ist derzeit nur für Konten mit Web-Abrechnung buchbar.',
      nummerFehlt: 'Bitte hinterlegen Sie zuerst Ihre UID oder Steuernummer in den Stammdaten. Eine falsche Nummer fällt erst bei der FinanzOnline-Meldung auf und verlangt einen Zertifikatstausch über den fiskaltrust-Support — dieser Aufwand wird verrechnet.',
      nummer: 'Hinterlegte Nummer: {nummer}',
      bestaetigenNummer: 'Diese Nummer ist richtig.',
      bestaetigenKosten: 'Ich habe die Kostenübersicht gelesen und bestelle das Modul kostenpflichtig.',
      absenden: 'Kostenpflichtig bestellen',
      stornieren: 'Bestellung stornieren',
      stornierenFrage: 'Bestellung zurückziehen? Das ist kostenlos — es wurde noch nichts eingerichtet.',
      kuendigen: 'Modul kündigen',
      // AK16 gehört in den Dialog: der Kündigungsmonat wird noch voll berechnet —
      // wer das erst auf der Rechnung erfährt, hält es für einen Fehler.
      kuendigenFrage: 'Modul zum Monatsende kündigen? Der laufende Monat wird noch voll berechnet; die Kasse signiert bis dahin weiter, und die Abmeldung in FinanzOnline ist danach Ihre Pflicht.',
      kuendigenAb: 'Kündbar frühestens zum {datum}.',
      veraltet: 'Die Kostenübersicht ist nicht mehr aktuell — bitte neu laden und erneut bestätigen.',
    },
    kosten: {
      titel: 'Kostenübersicht',
      preis: 'Modulpreis: {preis} pro Monat zzgl. USt., zusätzlich zum Paketpreis.',
      pflichten: 'Nur Sie selbst können: die Registrierung von Kasse und Signatureinheit in FinanzOnline, die Prüfung des Startbelegs mit der BMF-Belegcheck-App und die jährliche Prüfung des Jahresbelegs bis 15. Februar.',
      support: 'Aufwand durch falsch hinterlegte Daten — insbesondere eine falsche Steuernummer/UID (Zertifikatstausch über den fiskaltrust-Support) oder ein Tippfehler beim AES-Schlüssel in FinanzOnline — wird nach tatsächlichem Aufwand zum jeweils gültigen Stundensatz verrechnet.',
      supportWeg: 'fiskaltrust leistet keinen Endkundensupport; Ihr Ansprechpartner ist AUVISO.',
      meldepflicht: 'Ausfälle der Kasse von mehr als 48 Stunden müssen Sie selbst in FinanzOnline melden.',
      mindestbezug: 'Mindestbezugsdauer zwölf Monate, danach monatlich zum Monatsende kündbar.',
      beginn: 'Der Zuschlag beginnt mit dem Folgemonat der Aktivierung; der Rest des Aktivierungsmonats ist beitragsfrei.',
    },
    pflichten: {
      // Vorgang 018, Schnitt 5: die Pflichten am Modulstatus (AK3b sinngemäß,
      // AK17, T45). KEIN Betrag (AK12) — der Stundensatz bleibt ein Verweis.
      titel: 'Ihre Pflichten als Betreiber der Kasse',
      finanzonline: 'Die Registrierung von Kasse und Signatureinheit in FinanzOnline können nur Sie selbst vornehmen.',
      startbeleg: 'Den Startbeleg mit der BMF-Belegcheck-App prüfen — erst diese Prüfung bestätigt die Kette.',
      jahresbeleg: 'Den Jahresbeleg jedes Jahr bis 15. Februar in FinanzOnline prüfen lassen.',
      dep: 'Das Datenerfassungsprotokoll ist sieben Jahre aufzubewahren. StaySuite legt wöchentlich einen Abzug ab — das unterstützt Sie, ersetzt Ihre Pflicht als Unternehmer aber nicht.',
      kuendigung: 'Mindestbezugsdauer zwölf Monate; danach monatlich zum Monatsende kündbar, der Kündigungsmonat wird als letzter voller Monat berechnet.',
      support: 'Aufwand durch eine falsch hinterlegte Steuernummer oder UID wird nach tatsächlichem Aufwand zum jeweils gültigen Stundensatz verrechnet.',
      // Nach der Kündigung (AK17): die Kasse gehört rechtlich dem Unternehmer.
      abmeldung: 'Die Abmeldung der Kasse in FinanzOnline ist Ihre Pflicht — die Registrierkasse gehört rechtlich Ihnen, nicht StaySuite.',
    },
  },
  steuernummer: {
    // Vorgang 018: das Feld in den Stammdaten. KEIN Betrag in diesen Texten
    // (AK12) — der Modulpreis kommt zur Laufzeit aus der Datenbank.
    label: 'Steuernummer',
    hint: 'Österreichische Steuernummer (neun Ziffern), z. B. 12-345/6789. Leer lassen, wenn nur eine UID vorliegt.',
    invalid: 'Das ist keine gültige Steuernummer — erwartet werden neun Ziffern, z. B. 12-345/6789. Es wurde nichts gespeichert.',
  },
  touristTax: {
    title: 'Ortstaxe',
    municipality: 'Gemeinde',
    perPersonNight: 'pro Person und Nacht',
    exemptUnder: 'Befreit unter {n} Jahren',
    report: 'Ortstaxen-Meldung',
    personNights: 'Nächtigungen',
    liable: 'Abgabepflichtig',
    exempt: 'Befreit',
    unknownAges: 'Alter der Kinder unbekannt — als abgabepflichtig gerechnet',
  },
  housekeeping: {
    title: 'Reinigung',
    turnover: 'Wechseltag',
    turnoverHint: 'Heute Abreise UND Anreise — muss bis zum Check-in fertig sein.',
    nextArrival: 'Nächste Anreise',
    noArrival: 'Keine Folgebuchung',
    done: 'Erledigt',
    nothing: 'Heute ist nichts zu reinigen.',
    departed: 'Abgereist',
  },
  dashboard: {
    todayArrivals: 'Anreisen heute',
    todayDepartures: 'Abreisen heute',
    openInvoices: 'Offene Rechnungen',
    occupancy30: 'Auslastung 30 Tage',
    revenue: 'Umsatz',
  },
  abo: {
    laden: {
      // Vorgang 009, Schnitt 8 — ladenneutral (ADR: „i18n-Schlüssel
      // ladenneutral"), heute nur vom Apple-Kaufblatt benutzt. KEIN Betrag in
      // diesen Texten: der Preis kommt ausschließlich aus dem Laden (AK32).
      titel: 'Abo',
      kaufen: 'Abo abschließen',
      wiederherstellen: 'Käufe wiederherstellen',
      verwalten: 'Abo verwalten',
      // Kündigung geschieht ausschließlich beim Laden (Apple: iOS-Einstellungen
      // → Abos) — dieselbe Aussage wie kontoLoeschung.aboApple (Vorgang 019).
      verwaltenHinweis: 'Kündigung und Paketwechsel laufen über den App Store. „Abo verwalten“ öffnet die Abo-Einstellungen Ihres Kontos.',
      nurInhaber: 'Das Abo schließt der Kontoinhaber ab.',
      // Die minimale Zustandszeile (AU2: „Abo-Zustand sichtbar") — bewusst nur
      // drei grobe Lagen aus billingStage(); die feinen Ladenzustände
      // (gekündigt ab, Zahlung wird wiederholt, …) kommen erst mit der
      // Statuswirkung nach 015/2b (AP9 offen). Ohne Betrag, ohne Datum außer
      // dem Testphasen-Ende.
      zustandAktiv: 'Ihr Abo ist aktiv.',
      zustandTest: 'Testphase läuft bis {datum}.',
      zustandLesend: 'Dieses Konto ist derzeit nur lesend. Ihre Daten bleiben erhalten.',
      andererKanal: 'Dieser Betrieb bezahlt bereits über einen anderen Weg.',
      fremderBetrieb: 'Dieses Abonnement gehört bereits zu einem anderen Betrieb.',
      erstattungBeimLaden: 'Die Zahlung konnte nicht zugeordnet werden. Eine Erstattung läuft über den App Store, nicht über AUVISO.',
      pruefbuild: 'Interner Prüfbuild — die Kaufumgebung wird vom App Store bestimmt.',
      sandkasten: 'Sandkasten-Umgebung — es wird nichts abgebucht.',
      ladeFehler: 'Die Produkte konnten nicht aus dem Laden geladen werden.',
      abgebrochen: 'Der Kauf wurde abgebrochen.',
      ausstehend: 'Die Zahlung wartet auf Bestätigung durch den App Store.',
      aktiviert: 'Ihr Abo wurde bestätigt und ist aktiv.',
      keinKauf: 'Es wurden keine Käufe für dieses Apple-Konto gefunden.',
      kaufFehler: 'Der Kauf wurde nicht abgeschlossen.',
      gemeldet: 'Der Kauf wurde an den Server gemeldet.',
      // Der Anspruch kommt aus StoreKit auf DIESEM Gerät (aktiveKaeufe), nicht
      // aus subscriptions — im LADEN_ANWENDEN=off-Modus wüsste der Server es
      // noch gar nicht. Erster Sandkasten-Kauf 20.08.2026: ohne diese Karte
      // standen unter einem laufenden Abo weiter drei Kaufknöpfe.
      kaufVorhanden: 'Ihr Abo läuft über den App Store.',
    },
  },
}

export type Dict = typeof de
